import React from 'react';
import PropTypes from 'prop-types';

import SearchResult from '../src/SearchResult';
import SearchItem from './SearchItem';

const SearchResults = ({ result, loading, onLoadMore }) => (
    <div className='search-results'>
        <div className='search-results__info a-subtitle -center'>
            {loading && <span>Bezig met zoeken.</span>}
            {!loading && result.isEmpty() && (
                <span>
                    Er is geen pagina waarop dit zoekwoord staat.
                    Probeer je even opnieuw met een andere term?
                </span>
            )}
            {!loading && result.getTotal() === 1 && <span><strong>1 resultaat</strong> gevonden.</span>}
            {!loading && result.getTotal() > 1 && <span><strong>{result.totalResults} resultaten</strong> gevonden.</span>}
        </div>
        {!result.isEmpty() && (
            <div className='search-results__items l-block-t l-block-b'>
                {result.items && result.items.map((item, index) => (
                    <SearchItem key={index} item={item} />
                ))}
            </div>
        )}
        {result.getTotalLoaded() < result.getTotal() && (
            <div className='search-results__load-more'>
                <button className='btn btn--sm btn--search' onClick={onLoadMore}>
                    Meer laden
                </button>
            </div>
        )}
    </div>
);

SearchResults.propTypes = {
    result: PropTypes.instanceOf(SearchResult).isRequired,
    loading: PropTypes.bool.isRequired,
    onLoadMore: PropTypes.func.isRequired,
};

export default SearchResults;
